$(function(){
	// breadcrumb management
	if($('.mod_breadcrumb+.mod_article>.heroFW.go-first:first-child').length)
		$('.mod_breadcrumb+.mod_article>.heroFW.go-first:first-child').after($('.mod_breadcrumb'));
	if($('.mod_breadcrumb+.mod_article>.sliderFW.go-first:first-child').length)
		$('.mod_breadcrumb+.mod_article>.sliderFW.go-first:first-child').after($('.mod_breadcrumb'));
	$('.mod_breadcrumb').addClass('active');
});


// WEBPACK FOOTER //
// ./src/themes/audioaccess/audioaccess.js